import { forwardRef, type Ref, type SVGProps } from "react";
const IconCafeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M12 25c-5 0-5.98-6.135-6-16.764C5.998 7 6.894 6 7.999 6H22c1.106 0 2.002 1.001 2 2.236q0 .405-.003.803c.636.05 1.303.162 1.897.417.586.251 1.137.651 1.53 1.277.39.62.576 1.379.576 2.267 0 1.653-.416 3.002-1.485 3.893-.81.675-1.868.975-3.05 1.07C22.763 22.513 21.22 25 18 25zm11.714-9.075c.719-.102 1.2-.301 1.52-.568.432-.36.766-1.01.766-2.357 0-.612-.127-.977-.268-1.202-.138-.218-.337-.38-.626-.504-.321-.138-.704-.211-1.137-.25-.039 1.784-.117 3.415-.256 4.88"
      clipRule="evenodd"
    />
    <path d="M6 27a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1" />
  </svg>
);
const ForwardRef = forwardRef(IconCafeFilledSVG);
ForwardRef.displayName = "IconCafeFilled";
export { ForwardRef as IconCafeFilled };
